module.exports = __webpack_public_path__ + "img/team.bc1b07ea.jpg";